import Progress from "../_helpers/progress";

const ProgressStore = {
  isInProgress: false,
  start() {
    Progress.start();
    this.isInProgress = true;
  },
  stop() {
    Progress.stop();
    this.isInProgress = false;
  },
};

export const ProgressPlugin = {
  install(Vue) {
    Vue.mixin({
      data() {
        return {
          store: ProgressStore,
        };
      },
    });
    Object.defineProperty(Vue.prototype, "$progress", {
      get() {
        return this.$root.store;
      },
    });
  },
};
